import React, {ReactElement} from 'react';
import {UpdateSettingsButton} from 'components/UpdateSettingsButton';
import {Text} from 'components/Text';

export const Greetings = (): ReactElement => (
  <Text data-test='greetings'>
    По умолчанию показываем, сколько тратить в день, чтобы выжить на прожиточный минимум
    <UpdateSettingsButton />
  </Text>
);
